var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanceProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.271px",
    height: "13.104px",
    viewBox: "-0.021 0.105 16.271 13.104",
    enableBackground: "new -0.021 0.105 16.271 13.104",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M0.208,2v8.708c0,1.582,0.792,2.375,2.375,2.375h11.083c1.584,0,2.375-0.793,2.375-2.375V4.375 c0-0.438-0.354-0.792-0.791-0.792c-4.486,0-8.972,0-13.458,0C0.917,3.583,0.208,2.875,0.208,2z M12.084,6.75 c0.437,0,0.791,0.354,0.791,0.791c0,0.438-0.354,0.793-0.791,0.793c-0.438,0-0.793-0.355-0.793-0.793 C11.291,7.105,11.646,6.75,12.084,6.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    fillOpacity: 0.44,
    d: "M1.792,0.417C0.917,0.417,0.208,1.126,0.208,2s0.709,1.583,1.583,1.583 c4.222,0,8.445,0,12.667,0V1.209c0-0.438-0.355-0.792-0.793-0.792H1.792z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceProfile);
export default __webpack_public_path__ + "static/media/balanceProfile.01c82f18acd1454f8cd737c3f49a9380.svg";
export { ForwardRef as ReactComponent };